import AdminAgents from './AdminAgents';

export default function AdminSubagents() {
    return <AdminAgents agentType="sub_agent" />;
}
